// fullbleed.js

$.namespace("SCS.fullbleedCarousel");
SCS.fullbleedCarousel.timer = null;
SCS.fullbleedCarousel.holder = null;

$(function() {
	var stage = $('#scs-stage'),
		stageFlat = stage.find('.scs-stage-flat'),
		$slides = $('.scs-fullbleed-carousel-slide'),
		carouselContainer = $('.fullbleed'),
		stageFlatInner;

	if ($slides.length) {
		$('.fullbleed:not(.modBackgroundContainer)').addClass('carouselContainer normalCarouselContainer');

		if( stageFlat.length === 0 ) {
			stageFlat = $('<div class="scs-stage-flat"></div>');
			stage.append( stageFlat );

			if( stage.data("full-height") ){
				stageFlat.addClass( 'full-height-background' );
			}

			if( stage.data("bottom-align") ){
				stageFlat.addClass( 'bottom-align-background' );
			}

			if( stage.data("background-color").length > 0 ) {
				stageFlat.css('background-color', "#"+stage.data("background-color") );
			}
		}

		if( stage.data("stretch-image") ) {
			stageFlatInner = stageFlat.find('.scs-stage-flat-inner');

			if( stageFlatInner.length === 0 ) {
				stageFlatInner = $('<div class="scs-stage-flat-inner"></div>');
				stageFlat.append( stageFlatInner );
			}

			SCS.fullbleedCarousel.holder = stageFlatInner;
		}
		else {
			SCS.fullbleedCarousel.holder = stageFlat;
		}

		SCS.fullbleedCarousel.holder.find('.scs-stage-backgroundimage:not(.scs-fbslide-backgroundimage)').remove();

		var $slide = $slides.eq(0).fadeIn(800);
		$slide.attr({
			'id' : 'fbSlide0',
			'data-bg' : 'fbSlideBg0'
		});
		$slide.find('.scs-stage-backgroundimage').attr('id', 'fbSlideBg0').show();
		var theme = $slide.find('.scs-stage-backgroundimage').data('theme');
		SCS.fullbleedCarousel.setTheme(theme);
		SCS.fullbleedCarousel.appendBackground($slide);
	}

	if ($slides.length > 1) {
		$(window).on('load', function() {
			SCS.fullbleedCarousel.loadSlide(1);
		});
	}
	else {
		// still set the width of a single container only in Fullbleed Stage carousel.
		carouselContainer.find('ul.carousel-list > li.scs-fullbleed-carousel-slide').show().width(carouselContainer.closest('.carouselContainer').width());
	}
});

SCS.fullbleedCarousel.setTheme = function(theme) {
	var $middle = $('div.middle');
	var $backgroundCreator = $middle.is('.creates-background') ? $middle : $middle.find('#scs-stage.creates-background');
	var $header = $('.scs-pageheader > div');

	if (theme === "themeWhite") {
		$header.removeClass('scs-pageheader-themeDark background-contrast-is-dark').addClass('scs-pageheader-themeWhite background-contrast-is-light');
		$middle.removeClass("scs-body-themeDark").addClass("scs-body-themeWhite");
		$backgroundCreator.removeClass('background-contrast-is-dark').addClass('background-contrast-is-light');
	} else {
		$header.removeClass('scs-pageheader-themeWhite background-contrast-is-light').addClass('scs-pageheader-themeDark background-contrast-is-dark');
		$middle.removeClass("scs-body-themeWhite").addClass("scs-body-themeDark");
		$backgroundCreator.removeClass('background-contrast-is-light').addClass('background-contrast-is-dark');
	}
};

SCS.fullbleedCarousel.loadSlide = function(num) {
	var count = (!num) ? 1 : num;
	var $slides = $('.scs-fullbleed-carousel-slide');
	$slide = $slides.eq(count);
	$.get($slide.data("url"), function(data) {
		$slide.attr({
			'id' : 'fbSlide' + count,
			'data-bg' : 'fbSlideBg' + count
		}).html(data);
		$slide.find('.scs-stage-backgroundimage').attr('id', 'fbSlideBg' + count);
		SCS.fullbleedCarousel.appendBackground($slide);
		if (count + 1 < $slides.length) {
			SCS.fullbleedCarousel.loadSlide(count + 1);
		} else {
			SCS.fullbleedCarousel.init();

			SCS.lazyLoadImages($('#scs-stage'));
			// fix for slides with images not backgrounds
			$('#fbSlideBg0').show();
		}
	});
};

SCS.fullbleedCarousel.appendBackground = function(elem) {
	SCS.fullbleedCarousel.holder.append(elem.find('.scs-stage-backgroundimage'));
};

SCS.fullbleedCarousel.animateBackground = function(outElementId, inElementId) {
	var FADE_TIME = 800; // ms
	$("#" + outElementId).fadeOut(FADE_TIME);
	$("#" + inElementId).fadeIn(FADE_TIME);
	setTimeout(function() {
		var theme = $("#" + inElementId).data("theme");
		SCS.fullbleedCarousel.setTheme(theme);
	}, FADE_TIME / 2);
};

SCS.fullbleedCarousel.init = function() {
	var carouselContainer = $('.fullbleed');
	var carouselControls = $('.fullbleed-controls').fadeIn(1000);
	var buttons = carouselControls.find('.carousel-prev, .carousel-next').fadeIn(1000);

	if (carouselContainer.data('carousel-initialized')) {
		return;
	}
	carouselContainer.data('carousel-initialized', true);

	carouselContainer.find('ul.carousel-list > li').show().width(carouselContainer
		.closest('.carouselContainer').width());

	carouselContainer.scCarousel({
		onAfterInit : SCS.fullbleedCarousel.initCarouselCallback,
		onBeforeAnimation : function(instance, outElement, inElement) {
			buttons.hide();
			SCS.fullbleedCarousel.animateBackground($(outElement).data('bg'), $(inElement)
				.data('bg'));
			SCS.carousel.deactivateVideos(carouselContainer);
		},
		onAfterAnimation : function(instance, outElement, inElement) {
			buttons.show();
			SCS.carousel.activateVideo($(inElement));
		}
	});
};

SCS.fullbleedCarousel.initCarouselCallback = function(carousel) {

	var duration = carousel.container.find('.carousel-clip').data('duration');
	if (duration) {
		function updateTimerCallback(timer) {
			if (!timer) {
				clearTimeout(SCS.fullbleedCarousel.timer);
			}
			SCS.fullbleedCarousel.timer = timer;
		}
		function start() {
			SCS.carousel.autoSlide(carousel, duration, updateTimerCallback);
		}
		function stop() {
			updateTimerCallback(null);
		}
		var $stage = $(".stage").one("mousemove", function() {
			// handle case when mouse is already over the stage after page load
			if ($stage.is(":hover")) {
				stop();
			}
		}).mouseenter(stop)
			.mouseover(stop)
			.mouseleave(start);
		start();
	}

	SCS.carousel.circleNavigationInit(carousel);
};


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/fullbleed.js
// module id = 118
// module chunks = 0